import {
    getAlias,
    listAliases
} from './queries';
import {
    createAlias,
    deleteAlias,
    updateAlias,
} from './mutations';

import { GraphQLQuery } from 'aws-amplify/api';
import {
    Alias,
    CreateAlias,
    DeleteAlias,
    GetAlias,
    ListAliases,
    UpdateAlias
} from "../types.ts";
import {
    showErrorNotifications,
    showSuccessNotification
} from "../../../components/ServiceNotifications.tsx";
import {getIdentityId} from "../../../services/Cognito/Identities.ts";
import {fetchAuthSession} from "aws-amplify/auth";
import { client } from '../../email-api-integration';

export const fetchRecords = async ({
    limit = 10,
    nextToken = null,
    statusFilter = null,
    typeFilter = null
}: {
    limit?: number,
    nextToken?: string | null,
    statusFilter?: string | null,
    typeFilter?: string | null
} = {}) => {
    const filter: Record<string, string> = {};
    if (statusFilter) filter.aliasStatus = statusFilter;
    if (typeFilter) filter.aliasType = typeFilter;

    try {
        const response = await client.graphql<GraphQLQuery<ListAliases>>({
            query: listAliases,
            variables: {
                filter: filter,
                limit: limit,
                nextToken: nextToken
            },
        });
        const result = {
            items: response.data?.listAliases.items || [],
            nextToken: response.data?.listAliases.nextToken || null
        };
        
        if (result.items.length === 0) {
            return { items: [], nextToken: null };
        }
        
        return result;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
        return { items: [], nextToken: null };
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetAlias>>({
        query: getAlias,
        variables: {id: id},
    });
    return response.data?.getAlias;
};

export const add = async (payload: object) => {

    const session = await fetchAuthSession();

    const getIdentityIdOutput = await getIdentityId(session.tokens?.idToken?.toString() as string)

    const identityId = getIdentityIdOutput?.IdentityId

    try {
        const response = await client.graphql<GraphQLQuery<CreateAlias>>({
                                                                             query: createAlias,
                                                                             // FNP-639: send the identity-pool id under its real name (renamed from sub).
                                                                             variables: {input: {...payload, ...{identityId}}},
                                                                         });
        showSuccessNotification('Alias created');
        return response.data?.createAlias;
    } catch (e: any) {

        if (e.errors) {
            // filter out all other messages but the transaction cancelled exception
            e.errors = e.errors.filter((error: {
                errorType: string
            }) => error.errorType === 'DynamoDB:TransactionCanceledException')

            // iterate over the errors and replace the message if it is a duplicate
            e.errors.forEach((error: { errorType: string, message: string }) => {
                if (error.errorType === 'DynamoDB:TransactionCanceledException') {
                    error.message = 'Duplicate alias. please select another'
                }
            });
        }

        console.trace(e);
        showErrorNotifications(e)
    }
};

export const update = async (id: string, record: Alias) => {

    console.debug('IN UPDATE', id, record);

    // Whitelist to the fields UpdateAliasInput accepts (id, description, aliasType,
    // aliasStatus). Sending any other field of the fetched record (name, identityId,
    // accountId, createdByUsername, recordType, …) makes AppSync reject the whole
    // mutation with "field not defined for input object type 'UpdateAliasInput'"
    // (FNP-760). Whitelist, never blacklist — a delete-specific-fields trim silently
    // regresses whenever the record grows a new field.
    const input = {
        id: record.id,
        description: record.description,
        aliasType: record.aliasType,
        aliasStatus: record.aliasStatus,
    };

    try {
        const response = await client.graphql<GraphQLQuery<UpdateAlias>>({
                                                                             query: (updateAlias),
                                                                             variables: {input},
                                                                         });

        showSuccessNotification('Alias updated');
        return response.data?.updateAlias;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};

export const deleteRecord = async (id: string, name: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteAlias>>({
                                                                             query: (deleteAlias),
                                                                             variables: {
                                                                                 input: {
                                                                                     id: id,
                                                                                     name: name,
                                                                                 }
                                                                             },

                                                                         });
        showSuccessNotification('Alias deleted');
        return response.data?.deleteAlias;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};
